<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <h1 class="text-center px-2">Categorías</h1>
    </v-row>
    <v-row align="center" justify="center">
      <h2 class="text-center px-2">Edición 2024</h2>
    </v-row>
    <v-row align="center" justify="center">
      <v-col v-bind:key="category.id" v-for="category in categories" cols="12" sm="12" md="12" lg="3" xl="3">
        <v-card class="pa-7 my-1 mx-2" @click="selectCategory(category)" outlined>
          <h3>{{ category.name }}</h3>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/award';

export default {
  name: "AwardCategories",
  data() {
    return {
      categories: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Repository.getAllCategoriesOfAward(3).then((response) => {
        if(response.status < 400)
          this.categories = response.data;
      });
    },
    selectCategory(category) {
      this.$router.push({name: 'nominees', params: {category: category}});
    }
  }
}
</script>

<style scoped>

</style>
